<template>
  <table class="table" :class="tableClass">
    <thead class="bg-primary text-white">
      <slot name="column_names">
        <th v-for="column_name in column_names" :key="column_name">{{column_name}}</th>
      </slot>
      <th v-if="edit_route || delete_route" style="width:1%"></th>
    </thead>
    <tbody>
      <tr v-for="(item, index) in data" :key="index">
        <slot :row="item">
          <td
            v-for="(column, index) in columns"
            :key="index"
            v-if="hasValue(item, column)"
          >{{itemValue(item, column)}}</td>
          <td v-if="edit_route || delete_route">
            <div class="btn-group">
              <router-link
                v-if="edit_route"
                class="btn btn-sm btn-primary"
                :to="{ name: edit_route , params: { id: item.id } }"
              >
                <i class="fas fa-edit"></i>
              </router-link>
              <router-link
                v-if="delete_route"
                class="btn btn-sm btn-primary"
                :to="{ name: delete_route, params: { id: item.id } }"
              >
                <i class="fas fa-trash-alt"></i>
              </router-link>
            </div>
          </td>
        </slot>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  name: "paper-table",
  // data() {
  //   return {
  //     delete_route: false,
  //     edit_route: false
  //   };
  // },
  props: {
    columns: Array,
    column_names: Array,
    data: Array,
    type: {
      type: String, // striped | hover
      default: "striped"
    },
    title: {
      type: String,
      default: ""
    },
    subTitle: {
      type: String,
      default: ""
    },
    edit_route: "",
    delete_route: ""
  },
  computed: {
    tableClass() {
      return `table-${this.type}`;
    }
  },
  methods: {
    hasValue(item, column) {
      return item[column.toLowerCase()] !== "undefined";
    },
    itemValue(item, column) {
      return item[column.toLowerCase()];
    }
  }
};
</script>
<style>
</style>
